export enum CONNECTED_SERVICES {
  NINE_AM_HEALTH = '9am_health',
  PERSONIFY = 'personify',
}

export type ConnectedService = `${CONNECTED_SERVICES}`

export const CONNECTED_SERVICE_NAMES: Record<ConnectedService, string> = {
  [CONNECTED_SERVICES.NINE_AM_HEALTH]: '9amHealth',
  [CONNECTED_SERVICES.PERSONIFY]: 'personify',
}

export const CONNECTED_SERVICE_PARAMS = {
  token: 'token',
  referral: 'referral',
}
